import React from 'react';
import styles from './sign.module.scss';
import sign from './sign.js';

export class Sign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        const { clearCanvas, saveImgInfo, getIsDrawed } = sign(this.refs.signCanvas, (type, value) => {
            if (type === 'confirm') {
                this.props.updateImgUrl(value);
            }
        });
        this.clearCanvas = clearCanvas;
        this.saveImgInfo = saveImgInfo;
        this.getIsDrawed = getIsDrawed;
    }

    // 清除签名
    toClearImg = () => {
        this.clearCanvas();
    }

    // 保存签名
    toSaveImgInfo = () => {
        this.saveImgInfo();
    }

    // 获取是否签名状态
    toGetIsDrawed = () => {
        return this.getIsDrawed();
    }

    render() {
        return (
            <canvas className={styles.sign_content} ref='signCanvas' width="350" height="250"></canvas>
        )
    }
}

export default Sign;